import * as SentryVue from "@sentry/vue";
import router from "@/router";
import { getAppInfo } from "./capacitor/appPlugin";
import { isAndroid, isDev } from "./env";

export const initSentry = async (app: any) => {
  if (isDev || !isAndroid) return; // dev mode return
  SentryVue.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      SentryVue.browserTracingIntegration({ router }),
      SentryVue.replayIntegration({
        // maskAllText: false,
        // blockAllMedia: true,
      }),
      // for issue: https://github.com/getsentry/sentry-capacitor/issues/759
      SentryVue.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: false,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      "192.168.13.226",
      /^https:\/\/yourserver\.io\/api/,
    ],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  const info = await getAppInfo();
  // 设置 Sentry extras
  SentryVue.setExtras(info);
  SentryVue.setTag("vin", info.vin || "");
  SentryVue.setUser({
    id: info.vin || info.deviceId || "",
    username: info.vin || info.deviceId,
  });
};
